const domains = {
  "fioresulmare.se": 3045,
  "restaurangfiore.se": 2757,
  "thebistrob.se": 2428,
};

export default domains;
